import React, { useState } from 'react';
import { Button, Select, SnapDialog, TextField } from '@one-snap/sparkles';
import PropTypes from 'prop-types';
import './IncomePageStyles.css';
import { FormControl, InputLabel, MenuItem } from '@mui/material';
import Footbar from './Footbar';
import CartAmountHeader from './CartAmountHeader';

function IncomePage({ isVisible, onClose, totalAmount, goBack, onContinue }) {
  const [payFrequency, setPayFrequency] = useState('Twice a Month');

  const handleButtonClick = (frequency) => {
    setPayFrequency(frequency);
  };

  return (
    <SnapDialog
      open={isVisible}
      onClose={onClose}
      className="custom-dialog-sm-width"
    >
      <div className="verification-page-div">
        <CartAmountHeader
          totalAmount={totalAmount}
          goBack={goBack}
          showCartAmount
        />
        <div className="awareness-content">
          <div className="lto-mob-vcode-1">Tell us about your income</div>
          <br />
          <div className="personal-info-title">
            How much is your typical paycheck?
          </div>
          <div className="personal-info-form">
            <div className="name-section">
              <TextField
                label="Amount"
                defaultValue="500"
                className="personal-info-tab-space"
                style={{ width: '100%' }}
              />
            </div>
            <br />
            <div className="personal-info-title">
              How often do you get paid?
            </div>
            <div className="pay-frequency-section">
              <Button
                className={`custom-toggle-button ${
                  payFrequency === 'Weekly' ? 'active' : ''
                }`}
                onClick={() => handleButtonClick('Weekly')}
                fullWidth
              >
                Weekly
              </Button>
              <Button
                className={`custom-toggle-button ${
                  payFrequency === 'Every Other Week' ? 'active' : ''
                }`}
                onClick={() => handleButtonClick('Every Other Week')}
                fullWidth
              >
                Every Other Week
              </Button>
              <Button
                className={`custom-toggle-button ${
                  payFrequency === 'Twice a Month' ? 'active' : ''
                }`}
                onClick={() => handleButtonClick('Twice a Month')}
                fullWidth
              >
                Twice a Month
              </Button>
              <Button
                className={`custom-toggle-button ${
                  payFrequency === 'Monthly' ? 'active' : ''
                }`}
                onClick={() => handleButtonClick('Monthly')}
                fullWidth
              >
                Monthly
              </Button>
            </div>
          </div>
          <br />
          <div className="personal-info-title">
            What dates of the month are you normally paid?
          </div>
          <FormControl fullWidth style={{ marginBottom: 5 }}>
            <InputLabel>First Pay Date</InputLabel>
            <Select
              label="First Pay Date"
              value="31"
              className="store-category-selection"
            >
              <MenuItem key="firstpaydate-001" value="31">
                31
              </MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel>Second Pay Date</InputLabel>
            <Select
              label="Second Pay Date"
              value="15"
              className="store-category-selection"
            >
              <MenuItem key="firstpaydate-002" value="15">
                15
              </MenuItem>
            </Select>
          </FormControl>
          <br />
          <br />
          <br />
          <Button className="continue-button" onClick={onContinue}>
            Continue
          </Button>
          <Footbar />
        </div>
      </div>
    </SnapDialog>
  );
}

IncomePage.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  totalAmount: PropTypes.string.isRequired,
  onContinue: PropTypes.func.isRequired
};

export default IncomePage;
